import { CALENDAR } from "../data/calendar.js";
import { rankOf } from "../data/levels.js";

const pad = (n) => String(n).padStart(2, "0");
export const isoDate = (y, m, d) => `${y}-${pad(m + 1)}-${pad(d)}`;

// Everything happening on one day: one-off dates, weekly recurrences that have
// started, and monthly-nth-weekday rules. Tier-gated entries are filtered out
// for anyone below their minLevel.
export function eventsOn(y, m, d, userRank) {
  const weekday = new Date(y, m, d).getDay();
  const iso = isoDate(y, m, d);
  const out = [];

  for (const e of CALENDAR.singles) {
    if (e.d === iso) out.push(e);
  }
  for (const e of CALENDAR.weekly) {
    if (
      weekday === e.weekday &&
      iso >= e.start &&
      (!e.minLevel || userRank >= rankOf(e.minLevel))
    ) {
      out.push(e);
    }
  }
  for (const e of CALENDAR.monthlyNth) {
    if (
      weekday === e.weekday &&
      Math.ceil(d / 7) === e.nth &&
      (!e.minLevel || userRank >= rankOf(e.minLevel))
    ) {
      out.push(e);
    }
  }
  return out;
}

// The next few events from today forward, for the "Save The Date" strip.
export function upcoming(userRank, limit = 4) {
  const out = [];
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const [firstY, firstM] = CALENDAR.months[0];
  const [lastY, lastM] = CALENDAR.months[CALENDAR.months.length - 1];

  const start = new Date(Math.max(today.getTime(), new Date(firstY, firstM, 1).getTime()));
  const end = new Date(lastY, lastM + 1, 0);

  for (let d = new Date(start); d <= end && out.length < limit; d.setDate(d.getDate() + 1)) {
    for (const e of eventsOn(d.getFullYear(), d.getMonth(), d.getDate(), userRank)) {
      if (out.length < limit) {
        out.push({ ...e, y: d.getFullYear(), m: d.getMonth(), day: d.getDate() });
      }
    }
  }
  return out;
}

export const MONTHS = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

export const MONTHS_SHORT = [
  "JAN", "FEB", "MAR", "APR", "MAY", "JUN",
  "JUL", "AUG", "SEP", "OCT", "NOV", "DEC",
];

export const DOW = ["S", "M", "T", "W", "T", "F", "S"];
